import { updateSlideInDeck } from "../editor/deckEditor.js";
import { deriveSlideTextSubject } from "../outline/outlineSlide.js";
import { buildComposedBackgroundPrompt } from "./composedBackgroundService.js";
import { isComposedBackgroundMode } from "../style/presets.js";
import { pollSurfImageJob, submitSurfImageJob } from "./surfImageJob.js";
/** @deprecated Prefer contextual prompts via `composeContextualImagePrompt` + slide text (F2-rev / F11). */
export function buildSlideBackgroundPrompt(style, slideIndex) {
    const safe = style.legibility.safeZones[0];
    const zone = safe
        ? `Keep a calm uncluttered region for text overlay at normalized x=${safe.x.toFixed(2)} y=${safe.y.toFixed(2)} w=${safe.w.toFixed(2)} h=${safe.h.toFixed(2)}.`
        : "Leave calm negative space for text widgets.";
    return [
        "16:9 presentation slide background ONLY.",
        "LOOK-ONLY — no text, no logos, no readable typography, no people faces.",
        `Slide index: ${slideIndex + 1}.`,
        `Style treatment: ${style.backgroundTreatment}`,
        `Realism: ${style.backgroundRealism}`,
        `Surface palette mood: ${style.palette.surface}, accent: ${style.palette.accent}`,
        zone,
    ].join(" ");
}
export async function generateSlideBackground(cfg, deck, slideIndex) {
    const slide = deck.slides[slideIndex];
    if (!slide)
        throw new Error("Slide non trovata");
    const prompt = isComposedBackgroundMode(deck.theme)
        ? buildComposedBackgroundPrompt(deck.theme, slide, slideIndex)
        : buildSlideBackgroundPrompt(deck.theme, slideIndex);
    const jobId = await submitSurfImageJob(cfg, "surf.slide.background", prompt);
    const outputAssetKey = await pollSurfImageJob(cfg, jobId);
    return { jobId, outputAssetKey };
}
export function setSlideBackgroundKey(deck, slideId, s3Key, jobId, prompt) {
    const slideIndex = deck.slides.findIndex((s) => s.id === slideId);
    const slide = slideIndex >= 0 ? deck.slides[slideIndex] : undefined;
    const contextualPrompt = prompt ??
        (slide ? deriveSlideTextSubject(slide) : buildSlideBackgroundPrompt(deck.theme, slideIndex));
    return updateSlideInDeck(deck, slideId, (s) => ({
        ...s,
        background: {
            kind: "image",
            s3Key,
            pendingJobId: jobId,
            prompt: contextualPrompt,
        },
    }));
}
/** FIFO: one background job at a time, in slide order. */
export async function generateAllSlideBackgrounds(cfg, deck, onProgress) {
    let nextDeck = deck;
    const total = deck.slides.length;
    for (let index = 0; index < total; index += 1) {
        const slide = nextDeck.slides[index];
        onProgress?.({ index, total, slideId: slide.id, status: "generating" });
        try {
            const { jobId, outputAssetKey } = await generateSlideBackground(cfg, nextDeck, index);
            nextDeck = setSlideBackgroundKey(nextDeck, slide.id, outputAssetKey, jobId);
            onProgress?.({ index, total, slideId: slide.id, status: "done" });
        }
        catch (e) {
            const message = e instanceof Error ? e.message : String(e);
            onProgress?.({ index, total, slideId: slide.id, status: "error", message });
            throw e;
        }
    }
    return nextDeck;
}
